// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RewardDetailSkeletonWrapper {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.RewardDetailSkeletonWrapper .banner {
  margin: 24px 0;
  border-radius: 20px;
}
@media (max-width: 768px) {
  .RewardDetailSkeletonWrapper .banner {
    margin: 14px 0;
  }
}
.RewardDetailSkeletonWrapper .cardDetailSection {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 40px;
}
@media (max-width: 768px) {
  .RewardDetailSkeletonWrapper .cardDetailSection {
    flex-direction: column;
  }
}
.RewardDetailSkeletonWrapper .cardDetailSection .imageSection {
  width: 100%;
}
@media (max-width: 1200px) {
  .RewardDetailSkeletonWrapper .cardDetailSection .imageSection {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .RewardDetailSkeletonWrapper .cardDetailSection .imageSection {
    width: 100%;
  }
}
.RewardDetailSkeletonWrapper .cardDetailSection .imageSection .titleSection {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 32px;
}
@media (max-width: 768px) {
  .RewardDetailSkeletonWrapper .cardDetailSection .imageSection .titleSection {
    flex-direction: column;
  }
}
.RewardDetailSkeletonWrapper .cardDetailSection .imageSection .titleSection .imageContainer {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@media (max-width: 1200px) {
  .RewardDetailSkeletonWrapper .cardDetailSection .imageSection .titleSection .imageContainer {
    width: 100%;
  }
}
.RewardDetailSkeletonWrapper .cardDetailSection .imageSection .titleSection .imageContainer .text {
  display: flex;
  gap: 20px;
}
.RewardDetailSkeletonWrapper .cardDetailSection .imageSection .titleSection .cardContainerSection {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@media (max-width: 1200px) {
  .RewardDetailSkeletonWrapper .cardDetailSection .imageSection .titleSection .cardContainerSection {
    display: none;
  }
}
.RewardDetailSkeletonWrapper .cardDetailSection .imageSection .titleSection .cardContainerSection .cardDetail {
  display: flex;
  margin: 8px 0;
  gap: 20px;
}
.RewardDetailSkeletonWrapper .cardDetailSection .infoSection {
  width: 50%;
}
@media (max-width: 1200px) {
  .RewardDetailSkeletonWrapper .cardDetailSection .infoSection {
    width: 100%;
  }
}
.RewardDetailSkeletonWrapper .bottomSection {
  margin: 24px 0;
}
@media (max-width: 768px) {
  .RewardDetailSkeletonWrapper .bottomSection {
    margin: 14px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Partials/SkeletonUI/RewardDetailSkeleton/RewardDetailSkeleton.scss","webpack://./src/Styles/_mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,cAAA;EACA,mBAAA;AAAJ;ACGE;EDLA;IAKI,cAAA;EACJ;AACF;AAEE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAAJ;ACRE;EDIA;IAOI,sBAAA;EACJ;AACF;AACI;EACE,WAAA;AACN;ACEE;EDJE;IAII,WAAA;EAEN;AACF;ACrBE;EDcE;IAQI,WAAA;EAGN;AACF;AADM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAGR;AChCE;EDyBI;IAOI,sBAAA;EAIR;AACF;AAFQ;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAIV;ACzBE;EDiBM;IAOI,WAAA;EAKV;AACF;AAHU;EACE,aAAA;EACA,SAAA;AAKZ;AADQ;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAGV;ACxCE;EDiCM;IAOI,aAAA;EAIV;AACF;AAFU;EACE,aAAA;EACA,aAAA;EACA,SAAA;AAIZ;AAEI;EACE,UAAA;AAAN;ACrDE;EDoDE;IAII,WAAA;EACN;AACF;AAGE;EACE,cAAA;AADJ;AC/EE;ED+EA;IAII,cAAA;EAAJ;AACF","sourcesContent":["@import \"src/Styles/theme.scss\";\n.RewardDetailSkeletonWrapper {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n\n  .banner {\n    margin: 24px 0;\n    border-radius: 20px;\n\n    @include respond-md {\n      margin: 14px 0;\n    }\n  }\n\n  .cardDetailSection {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    gap: 40px;\n\n    @include respond-md {\n      flex-direction: column;\n    }\n\n    .imageSection {\n      width: 100%;\n\n      @include respond-xxlg {\n        width: 100%;\n      }\n\n      @include respond-md {\n        width: 100%;\n      }\n\n      .titleSection {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        gap: 32px;\n\n        @include respond-md {\n          flex-direction: column;\n        }\n\n        .imageContainer {\n          width: 50%;\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n\n          @include respond-xxlg {\n            width: 100%;\n          }\n\n          .text {\n            display: flex;\n            gap: 20px;\n          }\n        }\n\n        .cardContainerSection {\n          width: 50%;\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n\n          @include respond-xxlg {\n            display: none;\n          }\n\n          .cardDetail {\n            display: flex;\n            margin: 8px 0;\n            gap: 20px;\n          }\n        }\n      }\n    }\n\n    .infoSection {\n      width: 50%;\n\n      @include respond-xxlg {\n        width: 100%;\n      }\n    }\n  }\n\n  .bottomSection {\n    margin: 24px 0;\n\n    @include respond-md {\n      margin: 14px 0;\n    }\n  }\n}","@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
